<style scoped>

</style>
<style lang="less">
    .mine-contract-payee-company-poptip{
        width: 100%;
        line-height: 1;
        .ivu-poptip-rel{
            width: 100%;
        }
    }
</style>
<template>
  <PageContain>
    <div
    
      class="contract-group-container"
    >
      <div class="line text-center">
        <Button
          type="primary"
          icon="md-add"
          @click="editContract()"
        >
          添加
        </Button>
        <space />
        <Button
          type="warning"
          @click="showTemplateDownModal=true"
        >
          合同模板下载
          <Icon type="arrow-down-b" />
        </Button>
        <space />
        <div
          v-if="in_legal_group"
          style="display: inline-block"
        >
          <!-- 法务人员审核配置 -->
          <Button
            type="primary"
            @click="editContractConfig"
          >
            法务审核人员配置
          </Button>
          <space />
          <Button
            type="primary"
            @click="editTemplateConfig"
          >
            合同模板配置
          </Button>
        </div>
        <space />
        <div
          v-if="has_ly_config_button"
          style="display: inline-block"
        >
          <!-- 法务人员审核配置 -->
          <Button
            type="primary"
            @click="editLYContractConfig"
          >
            履约审核人员配置
          </Button>
        </div>
      </div>
      <div class="line text-center">
        <v-btn-toggle
          v-model="params.search_type"
          small
          mandatory
          @change="searchTypeChange"
        >
          <v-btn
          
            height="32"
            value="pending"
          >
            待我处理
          </v-btn>

          <v-btn
            height="32"
            value="related"
          >
            与我相关
          </v-btn>

          <v-btn
            height="32"
            value="mine"
          >
            我发起的
          </v-btn>
          <v-btn
            height="32"
            value="manager"
          >
            我管理的
          </v-btn>
          <v-btn
            height="32"
            value="draft"
          >
            草稿箱
          </v-btn>
          <v-btn
            v-if="cur_customer.is_pl"
            height="32"
            value="team"
          >
            我的团队
          </v-btn>
        </v-btn-toggle>
        <!-- <RadioGroup
        v-model="params.search_type"
        type="button"
        @on-change="searchTypeChange"
      >
        <Radio label="pending">
          待我处理
        </Radio>
        <Radio label="related">
          与我相关
        </Radio>
        <Radio label="mine">
          我发起的
        </Radio>
        <Radio label="draft">
          草稿箱
        </Radio>
        <Radio
          v-if="cur_customer.is_pl"
          label="team"
        >
          我的团队
        </Radio>
      </RadioGroup> -->
        <space />
        <div
          v-show="params.search_type!=='draft'"
          style="display:inline-block"
        >
          <v-select
            v-model="params.e_file_uploaded"
            style="width:160px;display:inline-block"
            small
            clearable
            height="32"
            item-text="label"
            item-value="value"
            :items="[{
              label: '是',
              value: true
            },{
              label: '否',
              value: false
            }]"
            label="是否上传电子件"
            @change="doSearch"
          />
          <!-- <Select
          v-model="params.e_file_uploaded"
          style="width:160px"
          clearable
          placeholder="是否上传电子件"
        >
          <Option
            :value="1"
          >
            是
          </Option>
          <Option
            :value="0"
          >
            否
          </Option>
        </Select> -->
          <space />
          <!-- <Input
          v-model="params.search"
          placeholder="输入关键字搜索"
          style="width: 180px"
          @on-enter="doSearch"
        /> -->
          <v-text-field
            v-model="params.search"
            clearable
            style="width: 180px;display: inline-block"
            label="关键字"
            placeholder="输入关键字搜索"
            @keydown="searchKeyDown"
          />
          <space />
          <v-btn
            height="32"
            depressed
            color="primary"
            @click="doSearch"
          >
            搜索
          </v-btn>
          <Ajaxbtn
            v-show="false"
            ref="searchBtn"
            :url="get_contracts_path"
            :params="params"
            type="search"
            @before="beforeSearch"
            @done="handleContractData"
            @fail="handleContractFail"
          />
        </div>
      </div>
      <div
        class="list-container"
      >
        <Table
          v-if="params.search_type==='draft'"
          :columns="contract_draft_columns"
          size="small"
          :max-height="table_height"
          :data="contracts || []"
          no-data-text="暂时无数据"
        />
        <PageContain :reserved-height="300">
          <VTable 
            v-if="params.search_type!=='draft'"
            fixed-header
            :fixed-header-zindex="3"
            dense
            :loading="loading"
            :headers="contract_columns"
            :desserts="contracts"
            :td-style="contract_table_style" 
          />
        </PageContain>
      <!-- <Table
        v-if="params.search_type!=='draft'"
        :columns="contract_columns"
        size="small"
        :max-height="table_height"
        :data="contracts"
        :loading="loading"
        :no-data-text="empty_tip"
        @on-expand="expandTable"
      /> -->
      </div>

      <div
        v-if="params.search_type!=='draft'"
        class="line paginate-fix-bottom"
      >
        <Page
      
          show-total
          show-elevator
          :current="page_info.current"
          :total="page_info.total"
          :page-size="page_info.page_size"
          @on-change="pageChange"
        />
      </div>

      <!-- <ContractEditor
      ref="editor"
      :contract_types="contract_types"
      :contract_type_hash="contract_type_hash"
      @on-update="updateContract"
    /> -->
      <LegalAuditUserEditor
        ref="legalAuditUserEditor"
        v-model="showLegalModal"
        :source-data="legalModalData"
        @closeModal="editContractConfig"
      />
      <StockUserEditor 
        ref="editLYContractConfig"
        v-model="showLegalModal"
        :source-data="legalModalData"
      />
      <LegalFileDownloadEdit
        v-model="showTemplateModal"
        :source-data="templateModalData"
        @closeModal="editTemplateConfig"
      />
      <LegalFileDownloadList
        v-model="showTemplateDownModal"
        @closeModal="showTemplateDownModal = false"
      /> 
      <EditModal
        ref="edit_modal"
        @next="next"
      />
      <EditNextModal 
        ref="edit_next_modal"
        @success="()=>{

          doSearch()  
        }"
        @needTfModal="needTfModal"
      /> 
      <ContractDetailPendingModal
        ref="smodal"
        @success="doSearch"
      />
    </div>
    <TfModal
      ref="tf_modal"
      contract-type="contract"
    />
  </PageContain>
</template>
<script route="/business/contract">
  import { getsafe } from '@/libs/util.js'
  import {VAutocomplete} from 'vuetify/lib'
  import FlowUtil from '../../libs/flow_util';
  import VTable from '@/vuetify_custom/v-table/v3'
  import { handleUserFlow } from '@/views/components/flow/utils.js'
  import CompanyName from '../company/components/name';
  import TeamName from '../team/components/name';
  // import ViewerItem from '../components/viewer/item';
  import ContractUid from '../fin/components/contract_uid';
  import ContractEditor from '../contract/components/contract_editor';
  import ContractDetail from '../components/viewer/components/contract';
  import UserFlowBase from '../components/flow/user_flow_base';
  import LegalAuditUserEditor from '../config_components/legal_audit_user/editor'
  import StockUserEditor from '../config_components/legal_audit_user/editor_v1.jsx'
  import LegalFileDownloadEdit from './../config_components/legal_file_download/editor'
  import LegalFileDownloadList from './../config_components/legal_file_download/list'
  import TfModal from '@/views/business/components/TfModal.jsx'
  import {mapGetters} from "vuex";
  import GoPayment from './components/GoPayment.jsx'
  import Vue from 'vue';
  import Vuetify from "vuetify"; 
  import PageContain from '@/views/components/PageContain.vue'
  import EditModal from './components/EditModal'
  import EditNextModal from './components/EditNextModal'
  import {closeContractApi, contractCheckAddPaymentApi} from './service'
  import ContractDetailPendingModal from '@/views/business/components/ContractDetailPendingModal.jsx'
  import { CONTRACT_SEAL_APPLICATION, F_BLOGGER_RECORDS } from './constants'
  import VPopV from './components/v-pop-v.vue'
  // import FileUploader from '../components/file/uploader';
  export default {
    components: {ContractEditor, LegalAuditUserEditor, LegalFileDownloadEdit, LegalFileDownloadList, EditModal, EditNextModal, GoPayment, VTable, ContractDetailPendingModal, PageContain, StockUserEditor, TfModal },
    data() {
      this.goPayment = null
      return {
        showTemplateDownModal:false, // 模板下载
        showTemplateModal:false, // 模板配置弹窗
        showLegalModal:false, // 审核人员配置弹窗
        get_contracts_path: this.$util.api.es_query_mine_contract,
        loading: false,
        empty_tip: '获取数据中...',
        params: {
          per_page: 10,
          page: 1,
          search: '',
          team_id: 0,
          company_id: 0,
          contract_type_id: 0,
          search_type: 'pending',
          e_file_uploaded: null,
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        contracts: [],
        legalModalData:{
          id: 0,
          name:'',
          key_name:'',
          content:[]
        },
        templateModalData:{
          name: "合同模版",
          key_name: "contract-templates",
          content: []
        },
      }
    },
    computed: {
      has_ly_config_button() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash['ly_config_button']
      },
      contract_draft_columns() {
        return [
          {
            title: '名称',
            key: 'name',
            minWidth: 140,
          },
          {
            title: '创建时间',
            key: 'name',
            minWidth: 140,
            render(h, params) {
              const _created_time = params.row._created_time
              return h('span', {}, moment(_created_time).format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '更新时间',
            key: '_updated_time',
            minWidth: 140,
            render(h, params) {
              const _updated_time = params.row._updated_time
              return h('span', {}, moment(_updated_time).format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '操作',
            width: 140,
            align: 'center',
            fixed: 'right',
            render:(h, params) => {
              const ret = [
                h('Button', {
                  props: {
                    
                    type: 'text'
                  },
                  on:{
                    click:() => {
                      this.$refs.edit_modal.fromDraft(params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    
                    type: 'text'
                  },
                  on:{
                    click:() => {
                      this.$vModal.confirm({
                        title: '提示',
                        content:'是否删除该条草稿？',
                        onOk:() => {
                          let list = []
                          try {
                            list = JSON.parse(localStorage.getItem(`${CONTRACT_SEAL_APPLICATION}/${this.cur_customer.id}`))
                          } catch (error) {
                            list = []
                          }
                          list = list.filter(item => {
                            return Number(item._created_time) !== Number(params.row._created_time)
                          })
                          localStorage.setItem(`${CONTRACT_SEAL_APPLICATION}/${this.cur_customer.id}`, JSON.stringify(list))
                        }
                      })
                    }
                  }
                }, '删除')
              ]
              return h('div', ret);
            }
          }
        ]
      },
      contract_columns() {
        return [
          {
            expand:true,
            z_index:1,
            // width: 68,
            // fixed: 'left',
            
            renderv: (h, _, params) => {
              return h(ContractDetail, {
                props: {
                  model_id: params.id,
                  showTfAdd:true
                },
                on: {
                  addTf:(val, call) => {
                    this.$refs.tf_modal.edit(val, {
                      closeCall:call
                    })
                  }
                }
              })
            }
          },
          // {
          //   title: '详情',
          //   align: 'center',
          //   width: 55,
          //   renderv: (h, _, row) => {
          //     return h(ViewerItem, {
          //       props: {
          //         type: 'Contract',
          //         model_id: row.id,
          //       },
          //       'class': {
          //         link: true
          //       }
          //     }, '查看')
          //   }
          // },
          {
            text: '编号',
            value: 'uid',
            width: 180,
            renderv: (h, _, row) => {
              //  const row = params.row;
              const user_flow = row.user_flow
              let arr = null
              if (this.params.search_type === 'pending') {
                arr = handleUserFlow({user_flow, current_user_id:this.cur_customer.id, need_handle:true})
              }
             
              return h(ContractUid, {
                props: {
                  contract: row,
                  nodeStatus: arr
                }
              });
            }
          },
          {
            text: '名称',
            value: 'name',
            width: 190,
            renderv: (h, _, row) => {
              const _this = this
              const ret = [];
              ret.push(h('div', row.name));
              // .getSubType()
              ret.push(h('div', `[${_this.contract_types_hash.getSubType(row.contract_type_id)}]`));
              if (row.bill_type === 'OutSourcing') {
                ret.push(h('div', '[委外订单]'));
              }
              return h('div', ret);
            }
          },
          {
            text: '申请人',
            width: 100,
            renderv: (h, _, row) => {
              return (
                <div>
                  <CompanyName id={ row.company_id } short style={{display: 'block'}} />
                  <TeamName id={ row.team_id } style={{display: 'block'}} />
                  <CustomerName id={ row.apply_user_id } />
                </div>
              )
            }
          },
          {
            text: '对方公司',
            width: 180,
            value: 'payee_company',
            renderv: (h, _, row) => {

              const is_multi_payee = getsafe(row, 'multi_payee', false)
              const ret = [];
              ret.push(h('span', row.payee_company));
              if (is_multi_payee) {
                ret.push(h('span', {class:'color-error', style:'margin-left:5px'}, '[MV]'))
              }
              return h('div', ret);
            }
          },
          {
            text: '合同总价',
            align: 'end',
            width: 110,
            value: 'total_price',
            type: 'money_field',
            // renderv: (h, _, row) => {
            //   const ret = [];
            //   ret.push(h('span', [undefined, null, ''].includes(row.total_price) ? '-' : formattingNumber(row.total_price, 2)));
            //   return h('div', _, ret);
            // }
          },
          {
            text: '状态',
            width: 140,
            value: 'status',
            align: 'center',
            renderv: (h, _, row) => {
            
              const user_flow = row.user_flow;
              const ret = []
              
              if (user_flow) {
                ret.push(h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: row,
                    title: row.name
                  }
                }))
                ret.push(h('div', {
                  style: {
                    textAlign: 'left',
                    color: row.e_file_audit ? 'green' : ''
                  }
                }, row.e_file_audit ? '已经电子件审核' : ''))
              } else {
                ret.push(h('div', '-'))
              }
              return h('div', {}, ret)
            }
          },
          // {
          //   text: '申请付款',
          //   width: 100,
          //   align: 'center',
          //   renderv: (h, _, row) => {
          //     return h('Button', {
          //       props: {
          //         type: 'primary',
          //         size: 'small',
          //         disabled: FlowUtil.canEdit(row, this.cur_customer) || row.del
          //       },
          //       on: {
          //         click: () => {
          //           this.editContractExpenseGroup(row)
          //         }
          //       }
          //     }, '付款');
          //   }
          // },
          {
            text: '操作',
            width: 75,
            align: 'center',
            fixed: 'right',
            z_index:1,
            renderv: (h, _, row, index) => {
              const items = [];
              const user_flow = row.user_flow;
              if (row.is_auto) {
                return h('span')
              }
              if (!row.del && user_flow && user_flow.is_node_user) {
                items.push(h('DropdownItem', {
                  props:{name: 'edit', divided: true}
                }, '编辑'));
              }
              items.push(h('DropdownItem', {
                props:{name: 'payment', divided: true}
              }, '申请付款'))
              if (this.params.search_type === 'mine') {
                items.push(h('DropdownItem', {
                               props:{name: 'generate_virtual_child', divided: true}
                             }, 
                             [
                               h('span', {}, '生成虚拟子合同'),
                               h(VPopV)
                             ] 
                ))
              }
              if (FlowUtil.canEdit(row, this.cur_customer)) {
                items.push(h('DropdownItem', {
                  props:{name: 'delete', divided: true}
                }, '废弃'));
              }
              items.push(h('DropdownItem', {
                props:{name: 'finish', divided: true}
              }, '完结'))
              items.push(h('DropdownItem', {
                props:{name: 'is_not_close', divided: true}
              }, '未完结'))
              if (!items.length) {
                return h('div', '-');
              }

              return h('Dropdown', {
                props: {
                  trigger: 'click',
                  placement: 'left',
                  size: 'small'
                },
                on: {
                  'on-click': (event_name) => {
                    this.handleContractEvent(event_name, row, index);
                  }
                }
              }, [
                h('div', {
                  class: {
                    link: true
                  }
                }, [
                  h('span', '操作'),
                  h('Icon', {
                    props: {
                      type: 'ios-arrow-down'
                    }
                  })
                ]),
                h('DropdownMenu', {
                  slot: 'list'
                }, items)
              ]);
            }
          }
        ]
      },
      contract_table_style() {
        return {
          "font-size": "12px",
          "padding": "5px 16px"
        }
      },
      table_height() {
        const window_height = this.$store.state.window_height;
        return window_height - 270;
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      select_teams() {
        const teams = [];
        teams.push({id: 0, name: '所有团队'});
        this.teams.forEach((team) => {
          teams.push(team);
        });
        return teams;
      },
      ...mapGetters({
        contract_types_hash:'async/contract_types_hash',
        contract_types: 'async/contract_types',
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
      }),
      in_legal_group() {
        const groups = this.$store.state.cur_customer.groups;
        return groups.includes('GROUP_LEGAL');
      },
    },

    created() {
      this.contract_types // 拉数据
      window.addEventListener("setItemEvent", () => this.draftData());
      //
    },
    destroyed() {
      window.removeEventListener("setItemEvent", () => this.draftData());
      if (this.goPayment) {
        this.goPayment.$destroy()
        this.goPayment = null
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      needTfModal(params) {
   
        this.$refs.tf_modal.edit(params)
      },
      notClose(data) {
        this.$refs.smodal.edit({...data, type:1})
      },
      searchKeyDown(e) {
        if ([e.code, e.key].map(i => i.toLocaleLowerCase()).includes('enter')) {
          this.doSearch()
        }
      },
      draftData(val = this.params.search_type) {
        if (val !== 'draft') {
          return 
        }
        setTimeout(() => {
          let list = []
          try {
            list = JSON.parse(localStorage.getItem(`${CONTRACT_SEAL_APPLICATION}/${this.cur_customer.id}`))
          } catch (error) {
            list = []
          }
          this.contracts = list
        }, 500)
      },
      finish(contract) {
        this.$vModal.confirm({
          title:'提示',
          content: '请确定是否将该合同做完结处理！',
          loading:true,
          onOk:({
            destroy,
          }) => {
            closeContractApi({id: contract.id, is_finish: true }).then(() => {
              this.$Message.success({
                content: '操作成功!'
              });
              this.$refs.searchBtn.doAjax()
            }).finally(() => {
              destroy()
              
            })
          }
                      
        })
      },
      next(data) {
        this.$refs.edit_next_modal.edit(data, {
          need_draft :true
        })
      },
      // 打开或关闭 法务审核人员配置 弹窗
      editContractConfig() {
        //   this.$refs.legalAuditUserEditor.edit()
        this.showLegalModal = !this.showLegalModal
      },
      // 打开或关闭 履约审核人员配置 弹窗
      editLYContractConfig() {
        this.$refs.editLYContractConfig.edit()
      //  this.showLegalModal = !this.showLegalModal
      },
      // 打开或关闭 模板配置弹窗
      editTemplateConfig() {
        this.showTemplateModal = !this.showTemplateModal
      },
      init() {
        this.doSearch()
        this.setContract()
        // this.getContractTypes(this.doSearch);
      },
      setContract() {
        let a = localStorage.getItem(F_BLOGGER_RECORDS)
        if (a) {
          a = JSON.parse(a)
        } else {
          return
        }
        this.$refs.edit_next_modal.generateFromBlogRecords(a)
        localStorage.removeItem(F_BLOGGER_RECORDS)
      },
      // getContractTypes(callback) {
      //   this.$util.ajax.get(this.$util.api.get_contract_types).then((response) => {
      //     return response.data;
      //   }).then((res) => {
      //     if (res.code === 1) {
      //       const data = res.data;
      //       this.handleContractTypes(data);
      //       callback && callback();
      //     } else {
      //       this.$Modal.error({
      //         title: '错误',
      //         content: res.msg
      //       });
      //     }
      //   }).catch((e) => {
      //     console.log(e);
      //   });
      // },
      // handleContractTypes(contract_types) {
      //   contract_types.forEach((contract_type) => {
      //     this.contract_type_hash[contract_type.id] = contract_type;
      //     if (contract_type.contract_types.length) {
      //       contract_type.children = contract_type.contract_types;
      //       this.handleContractTypes(contract_type.contract_types);
      //     } else {
      //       this.contract_types.push(contract_type);
      //     }
      //   });
      // },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.contracts = [];
      },
      searchTypeChange(val) {
        if (!val) {
          return 
        }
        if (val === 'draft') {
          this.contracts = []
          this.draftData(val)
          return 
        }
        this.doSearch();
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.loading = true;
        this.$refs.searchBtn.doAjax(true);
      },
      doSearch() {
        if (this.params.search_type === 'draft') {
          return 
        }
        this.params.page = 1;
        this.$refs.searchBtn.doAjax();
      },
      handleContractData(data) {
        this.loading = false;
        this.contracts = [];
        const contracts = data.contracts || []
        contracts.forEach((contract) => {
          this.contracts.push(contract);
        });
        if (contracts.length === 0) {
          this.empty_tip = '没有数据!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleContractFail(e) {
        e = e && e.message || e || ''
        this.loading = false;
        this.empty_tip = '获取数据失败';
        this.$Message.error('获取失败: ' + e);
        console.log(e);
      },
      handleContractEvent(event_name, contract) {
        switch (event_name) {
        case 'edit':
          this.editContract(contract);
          break;
        case 'generate_virtual_child':
          this.generateVirtualChild(contract);
          break
        case 'payment':
          this.editContractExpenseGroup(contract);
          break;
        case 'print':
          this.printContract(contract);
          break;
        case 'copy':
          this.copyContract(contract);
          break;
        case 'delete':
          this.deleteContract(contract);
          break;
        case 'edit_desc':
          this.editDesc(contract);
          break;
        case 'finish':
          this.finish(contract);
          break;
        case 'is_not_close':
          this.notClose(contract);
          break;
        default:
          this.$Message.error('未定义操作!');
          break;
        }
      },
      // 生成虚拟子合同
      generateVirtualChild(p) { 
        let text = ''
        if (p.is_virtual) {
          text = '虚拟合同不能生成虚拟子合同！'
        }
        if (p.is_closed && !text) {
          text = '已完结的合同不能生成虚拟子合同！'
        }
        if (text) {
          this.$vModal.warning({
            title:'提示',
            content: text
          })
          return 
        }
        this.$refs.edit_modal.getVirtualContractChildData(p).then(({params, contract}) => {
          // 只有支出类&非存货类才能生成虚拟子合同
          if (params.contract_sz_type === 'expense' && params.contract_type_bread_id === 'stockless') {
            const _this = this
            let company = null
            this.$vModal.confirm({
              title: '提示',
              loading: true,
              render:(h) => {
                return h('div', {}, [h(VAutocomplete, {
                  props: {
                    label: '付款集团内其他公司',
                    items:_this.companies.filter(i => i.id !== p.company_id),
                    'item-text': 'short_name',
                    'item-value': 'id'
                  },
                  on: {
                    change:(val) => {
                      company = _this.companies_hash[val]
                    }
                  }
                })])
              },
              onOk:({destroy, stopLoading}) => {
                if (!company) {
                  this.$Message.error('付款集团内其他的公司必选！')
                  stopLoading()
                  return
                }
                destroy()
                params.company_id = company.id
                this.$refs.edit_next_modal.handleFromMainChild({params, contract})
              }
            })

          } else {
            this.$vModal.warning({
              title:'提示',
              content: '支出类非存货类合同才能生成虚拟子合同！'
            })
          }
       
        })
      },
      editContract(contract) {
        this.$refs.edit_modal.edit(contract);
      },
      printContract(contract) {
        this.$refs.printer.print(contract);
      },
      copyContract(contract) {
        const new_contract = this.$util.clone(contract);
        delete new_contract.id;
        delete new_contract.uid;
        new_contract.fill_user_id = this.cur_customer.id;
        new_contract.fill_user = this.cur_customer.account;
        new_contract.status = 0;
        new_contract.contracts.forEach((contract) => {
          delete contract.id;
        });
        this.editContract(new_contract);
      },
      deleteContract(contract) {
        let del_reason = '';
        this.$Modal.confirm({
          title: '提示',
          render: (h) => {
            return h('div', [
              h('div', {
                class: {
                  'line': true,
                  'color-error': true
                }
              }, `你确定要废弃 ${contract.name} 吗?`),
              h('Input', {
                props: {
                  value: del_reason,
                  type: 'textarea',
                  maxlength: 200,
                  autofocus: true,
                  placeholder: '请输入废弃的原因'
                },
                on: {
                  input: (val) => {
                    del_reason = val;
                  }
                }
              })
            ]);
          },
          onOk: () => {
            if (!del_reason.trim()) {
              this.$Message.error('请输入废弃的原因?');
              setTimeout(() => {
                this.deleteContract(contract);
              }, 500);
              return;
            }
            this.$util.ajax.post(this.$util.api.delete_contract, {
              id: contract.id,
              del_reason: del_reason
            }).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                contract.del = true;
                this.$Message.success('废弃成功!');
              } else {
                this.$Modal.error({title: '提示', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '提示', content: e.message});
            });
          }
        })
      },
      getCompanyNameById(id) {
        const company = this.companies_hash[id];
        return company ? company.name : '';
      },
      getTeamNameById(id) {
        const team = this.teams_hash[id];
        return team ? team.name : '';
      },
      updateContract(contract) {
        if (contract.user_flow) {
          this.$util.insertOrUpdateArrayItem(this.contracts, contract, true);
        } else {
          this.doSearch();
        }
      },
      editContractExpenseGroup(contract) {
        contractCheckAddPaymentApi({
          id: contract.id
        }).then(res => {
          if (res.can_add_payment) {
            localStorage.setItem('contract_id_fk', JSON.stringify(contract));
            window.open('/mine/expense_group_company', '_blank');
            return 
          }
          if (res.e_file_audit_allow) {
            this.$vModal.confirm({
              title: '提示',
              width:500,
              // content: tx,
              okText: '已经取得电子文件并知悉上述事项，需付款',
              render:(h) => {
                return h('div', {}, [
                  h('div', '该合同还未完成法务归档节点，若仍需付款，需上传电子文件以及补充事项理由，审核通过后可以申请付款～'),
                  h('div', 'ps：本付款属特批流程，需经过项目组负责人审批通过。')
                ])
              },
              onOk:() => {
                if (!this.goPayment) {
                  this.goPayment = new Vue({
                    vuetify: new Vuetify(),
                    store: this.$store,
                    render:(h) => {
                      return h(GoPayment, {
                        ref: 'c',
                        on:{
                          success:() => {
                            setTimeout(() => {
                              this.$refs.searchBtn.doAjax()
                            }, 300)
                          }
                        }
                      }) 
                    }
                  })
                  this.goPayment.$mount()
                }
                this.goPayment.$refs.c.edit(contract)
              }
            })
            return 
          }
          this.$vModal.warning({
            title: '提示',
            content: res.message
          })
        })
        // let tx = ''
        // /* ------------------- 不能付款 ---------------------- */
        // // if (contract.contract_nature === 'frame') {
        // //   tx = '不可对框架协议类合同直接付款，请在其关联的子合同上付款！' 
        // // }
        // if (contract.is_virtual) {
        //   tx = '虚拟合同不可付款'
        // }
        // if (!tx && contract.del) {
        //   tx = '已作废的合同不可付款'
        // }
        // if (!tx && contract.contract_nature === 'costless') {
        //   tx = '该合同收支类型是无收无支合同，不可申请付款，若有疑问请联系财务公共账号~' 
        // }

        // if (tx) {
        //   this.$vModal.warning({
        //     title: '提示',
        //     content: tx
        //   })
        //   return 
        // }
        // /* ------------------- 未完成法务盖章的单子 ------------------------ */
        // if (contract.status !== 'stamped') {
        //   tx = true
        // }
        // if (tx) {
        //   const _this = this

        //   return 
        // }
        // /* ------------------------------------------- */
        // localStorage.setItem('contract_id_fk', JSON.stringify(contract));
        // window.open('/mine/expense_group_company', '_blank');
      },
      downloadContract(contract_path) {
        window.open(contract_path, '_blank');
      }
    }
  }
</script>
